import { ofType } from 'redux-observable';
import { mergeMap, debounceTime } from 'rxjs/operators';
import { merge, of } from 'rxjs';

import { GET_CLIENT_PROFILE_ENTRIES } from '../types';
import { CLIENT_PROFILE_ENTRY_MESSAGES } from '../constants/clientProfileEntryMessages';
import { getClientProfileEntriesPending, getClientProfileEntriesFulfilled, getClientProfileEntriesRejected } from '../actions';
import { sendApiRequest, notifyError, notifyWarning } from '../../../actions';
import { filtersSelector } from '../selectors';
import generateError from '../../../utilities/generateError';

const createPayload = payload => ({
  method: 'get',
  url: 'client/get',
  onSuccess: [response => (response.data.length === 0
    ? notifyWarning(CLIENT_PROFILE_ENTRY_MESSAGES.NOT_FOUND)
    : getClientProfileEntriesFulfilled(response))],
  onError: [
    getClientProfileEntriesRejected,
    error => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: 'ajaxApi',
};

const getClientProfileEntriesEpic$ = (action$, state$) => action$.pipe(
  ofType(GET_CLIENT_PROFILE_ENTRIES.DEFAULT),
  debounceTime(500),
  mergeMap(({ payload }) => {
    const filters = filtersSelector(state$.value);
    return merge(
      of(getClientProfileEntriesPending()),
      of(sendApiRequest(createPayload({ ...payload, ...filters }), meta)),
    );
  }),
);

export default getClientProfileEntriesEpic$;


// WEBPACK FOOTER //
// ./src/features/client-profile/epics/getClientProfileEntriesEpic.js